import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import CountryCard from './CountryCard';
import CountryService from '../../../services/CountryService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  countryCard: {
    height: '100%'
  }
}));

const CountryList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const foo = async () => {
      const fetchData = typeof id !== 'undefined'
        ? await CountryService.getById(id)
        : await CountryService.getAll();

      if (fetchData?.code === 200) {
        if (id) {
          setCountries([fetchData.data]);
        } else {
          setCountries(fetchData.data);
        }
      }
    };

    foo();
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Paises"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {countries.map((country) => (
              <Grid
                item
                key={country.id}
                lg={4}
                md={6}
                xs={12}
              >
                <CountryCard
                  className={classes.countryCard}
                  country={country}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default CountryList;
